import React, { useState, useEffect } from "react";
import {
  MessageSquareText,
  AlertTriangle,
  FileSpreadsheet,
  Info,
} from "lucide-react";
import Commentbox from "./Commentbox/Commentbox";
import Loader from "../../../../../presentationals/Loader/Loader.component";
import { getDisbursalData, getEmiBreakdown, getCollectionSummary, getcollectionBreakdown } from "../../API's/Actioncreator";
import StyledTooltip from '../../common/StyledTooltip'
import CustomPopupTable from '../../common/CustomPopupTable'
import moment from "moment";
const commonMargin = window.innerWidth > 1800 ? "40px" : "20px"
const commonGap = window.innerWidth > 1800 ? "20px" : "14px"

const FONT = "'Inter', system-ui, -apple-system, sans-serif";

// Add custom scrollbar styles
const scrollbarStyles = `
  .emi-scroll-container::-webkit-scrollbar {
    height: 4px;
  }
  .emi-scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 2px;
  }
  .emi-scroll-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 2px;
  }
  .emi-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;


function useWindowSize() {
  const [size, setSize] = useState({ w: window.innerWidth });
  useEffect(() => {
    const fn = () => setSize({ w: window.innerWidth });
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return size;
}

function IconUsers({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}
function IconDollar({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  );
}
function IconCheckCircle({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  );
}
function IconAlertCircle({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}
function IconClipboard() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3B82F6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
    </svg>
  );
}


function StatCard({
  customId = 1,
  originalValue = 0,
  Icon,
  iconColor,
  iconBg,
  value,
  label,
  cardBg,
  compact,
  valueColor = "#111827",
  Border
}) {
  return (
    <div
      style={{
        flex: compact ? "1 1 calc(50% - 8px)" : "1 1 0",
        background: cardBg,
        borderRadius: 16,
        padding: compact ? "16px 18px" : "24px 28px",
        minWidth: 0,
        boxSizing: "border-box",
        border: Border
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginBottom: 10,
        }}
      >
        <div
          style={{
            width: compact ? 36 : 44,
            height: compact ? 36 : 44,
            borderRadius: "10px",
            background: iconBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Icon color={iconColor} />
        </div>
        {
          !(customId == 0) ?
            <StyledTooltip
              value={originalValue}
            >
              <span
                style={{
                  fontSize: "clamp(18px, 2vw, 26px)",
                  fontWeight: 700,
                  color: valueColor,
                  letterSpacing: "-0.5px",
                  lineHeight: 1,
                }}
              >
                {value}
              </span>
            </StyledTooltip>
            :
            <span
              style={{
                fontSize: "clamp(18px, 2vw, 26px)",
                fontWeight: 700,
                color: valueColor,
                letterSpacing: "-0.5px",
                lineHeight: 1,
              }}
            >
              {value}
            </span>
        }
      </div>
      <p
        style={{
          margin: 0,

          color: "#4A5565",
          fontWeight: 400,
          fontSize: "14px",
          fontWeight: 400,
        }}
      >
        {label}
      </p>
    </div>
  );
}

function FinCard({ label, value, pct, compact, originalValue }) {
  return (
    <div
      style={{
        flex: compact ? "1 1 calc(50% - 8px)" : "1 1 0",
        background: "#FFFFFF",
        borderRadius: 12,
        padding: compact ? "14px 16px" : "18px 20px",
        border: "0.8px solid #E5E7EB",
        minWidth: 0,
        boxSizing: "border-box",
      }}
    >
      <p
        style={{
          margin: "0 0 0px",
          fontSize: "14px",
          color: "#4A5565",
        }}
      >
        {label}
      </p>
      <StyledTooltip
        value={originalValue}
      >
        <p
          style={{
            margin: "4px 0 4px",
            fontSize: "20px",
            fontWeight: 700,
            color: "#101828",
            letterSpacing: "-0.3px",
          }}
        >
          {value}
        </p>
      </StyledTooltip>
      <p
        style={{
          margin: "10px 0px 0px 0px",
          fontSize: "clamp(10px, 12px, 13px)",
          color: "#6A7282",
        }}
      >
        {pct}
      </p>
    </div>
  );
}

function EmiCard({
  emi,
  cases,
  month,
  amount,
  collectedamount,
  breakdown,
  pct,
  accentColor,
  badgeBg,
  badgeColor,
  cardWidth,
  onMessageClick,
  onCardInfoClick,
  amountOriginal,
  collectedamountOriginal,
  collectableMonthToDate,
  collectableMonthToDateDisplay
}) {
  return (
    <div
      style={{
        width: cardWidth,
        flexShrink: 0,
        background: "#fff",
        borderRadius: 16,
        padding: "18px",
        border: "1.6px solid #D1D5DC",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 14,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
          <span
            style={{
              fontSize: "clamp(11px, 0.9vw, 13px)",
              fontWeight: 700,
              color: accentColor,
            }}
          >
            {emi} EMI
          </span>
          <span
            style={{
              background: badgeBg,
              color: badgeColor,
              borderRadius: 999,
              fontSize: "clamp(9px, 0.7vw, 10px)",
              fontWeight: 600,
              padding: "6px 12px",
              whiteSpace: "nowrap",
            }}
          >
            {cases} Cases
          </span>
        </div>
        <div style={{ display: "flex", gap: '5px' }}>
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 7,
              background: "#F3F4F6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(59, 130, 246, 0.51)",
            }}
          >
            <Info
              size={13}
              color="#155DFC"
              onClick={onCardInfoClick}
            />
          </div>
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 7,
              background: "#F3F4F6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(59, 130, 246, 0.51)",
            }}
          >
            <MessageSquareText
              size={13}
              color="#155DFC"
              onClick={onMessageClick}
            />
          </div>
        </div>
      </div>

      <p
        style={{
          margin: "0 0 2px",
          fontSize: "14px",
          color: "#4A5565",
          fontWeight: 400,
        }}
      >
        Month
      </p>
      <p
        style={{
          margin: "0 0 12px",
          fontSize: "24px",
          fontWeight: 700,
          color: "#364153",
          letterSpacing: "-0.3px",
        }}
      >
        {month}
      </p>

      <p
        style={{
          margin: "0 0 2px",
          fontSize: "14px",
          color: "#4A5565",
          fontWeight: 400,
        }}
      >
        Collectable Amount
      </p>
      <StyledTooltip value={amountOriginal}>

        <p
          style={{
            margin: "0 0 8px",
            fontSize: "clamp(18px, 2.5vw, 22px)",
            fontWeight: 700,
            color: "#00A63E",
            letterSpacing: "-0.5px",
          }}
        >
          {amount}
        </p>
      </StyledTooltip>
      {
        collectableMonthToDate != null &&
        <>
          <p
            style={{
              margin: "0 0 2px",
              fontSize: "14px",
              color: "#4A5565",
              fontWeight: 400,
            }}
          >
            Collectable Amount Till Date
          </p>
          <StyledTooltip value={collectableMonthToDate}>

            <p
              style={{
                margin: "0 0 8px",
                fontSize: "clamp(18px, 2.5vw, 22px)",
                fontWeight: 700,
                color: "#00A63E",
                letterSpacing: "-0.5px",
              }}
            >
              {collectableMonthToDateDisplay}
            </p>
          </StyledTooltip>
        </>
      }
      <p
        style={{
          margin: "3px 0 0 2px",
          fontSize: "14px",
          color: "#4A5565",
          fontWeight: 400,
        }}
      >
        Collected Amount
      </p>
      <StyledTooltip value={collectedamountOriginal}>

        <p
          style={{
            margin: "0 0 8px",
            fontSize: "clamp(18px, 2.5vw, 22px)",
            fontWeight: 700,
            color: "#00A63E",
            letterSpacing: "-0.5px",
          }}
        >
          {collectedamount}
        </p>
      </StyledTooltip>

      <div
        style={{
          borderTop: "1px solid #0000001F",
          paddingTop: 10,
          marginBottom: 10,
        }}
      >
        <p
          style={{
            margin: "0 0 7px",
            fontSize: "15px",
            color: "#4A5565",
            fontWeight: "400",
          }}
        >
          Breakdown
        </p>
        {breakdown && breakdown?.length > 0 && breakdown?.map ? (
          breakdown?.map((b, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 4,
              }}
            >
              <span
                style={{
                  fontSize: window.innerWidth > 1800 ? "15px" : "12px",
                  color: "#4A5565",
                  fontWeight: 400,
                }}
              >
                {b.label}
              </span>
              <StyledTooltip value={b.originalValue || 0}>
                <span
                  style={{
                    fontSize: window.innerWidth > 1800 ? "15px" : "12px",
                    fontWeight: 600,
                    // color: "#4A5565",
                    color: "#2F5BFF",
                    background: "#EEF4FF"
                  }}
                >
                  {b.value}
                </span>
              </StyledTooltip>
            </div>
          ))
        ) : (
          <div
            style={{ fontSize: window.innerWidth > 1800 ? "16px" : "12px", color: "#9CA3AF" }}
          >
            No breakdown data available
          </div>
        )}
      </div>

      <div style={{ borderTop: "1px solid #F3F4F6", paddingTop: 10 }}>
        <p
          style={{
            margin: "0 0 3px",
            fontSize: "14px",
            color: "#4A5565",
            fontWeight: 400,
          }}
        >
          % of Total Portfolio
        </p>
        <p
          style={{
            margin: 0,
            fontSize: "20px",
            fontWeight: 700,
            color: "#364153",
          }}
        >
          {pct}
        </p>
      </div>
    </div>
  );
}

function CollectionSummary({ rate, expected, collected, gap, expectedOriginal, collectedOriginal, gapOriginal, fullWidth }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        width: "100%",
      }}
    >

      <div
        style={{
          background: "#35A04F2B",
          borderRadius: 12,
          padding: "18px 20px",
          border: "1px solid #D1FAE5",
        }}
      >
        <p
          style={{
            margin: "0 0 8px",
            fontSize: "clamp(11px, 0.8vw, 13px)",
            fontWeight: 400,
            color: "#6B7280",
          }}
        >
          Overall Collection Rate
        </p>
        <p
          style={{
            margin: "0 0 16px",
            fontSize: "clamp(24px, 3vw, 32px)",
            fontWeight: 700,
            color: "#327E45",
            letterSpacing: "-1px",
            lineHeight: 1,
          }}
          title=""
        >
          {rate}
        </p>
        <div style={{ display: "flex", gap: 32 }}>
          <div>
            <p
              style={{
                margin: "0 0 3px",
                fontSize: "clamp(10px, 0.75vw, 12px)",
                fontWeight: 400,
                color: "#686C70",
              }}
            >
              Expected
            </p>
            <StyledTooltip value={expectedOriginal}>
              <p
                style={{
                  margin: 0,
                  fontSize: "clamp(12px, 0.9vw, 14px)",
                  fontWeight: 700,
                  color: "#686C70",
                }}
              >
                {expected}
              </p>
            </StyledTooltip>
          </div>
          <div>
            <p
              style={{
                margin: "0 0 3px",
                fontSize: "clamp(10px, 0.75vw, 12px)",
                fontWeight: 400,
                color: "#327E45",
              }}
            >
              Collected
            </p>
            <StyledTooltip value={collectedOriginal}>
              <p
                style={{
                  margin: 0,
                  fontSize: "clamp(12px, 0.9vw, 14px)",
                  fontWeight: 700,
                  color: "#327E45",
                }}
              >
                {collected}
              </p>
            </StyledTooltip>
          </div>
        </div>
      </div>


      <div
        style={{
          background: "#FFF5F5",
          borderRadius: 12,
          padding: "18px 20px",
          border: "1px solid #FECACA",
          marginTop: '10px'
        }}
      >
        <p
          style={{
            margin: "0 0 8px",
            fontSize: "clamp(11px, 0.8vw, 13px)",
            fontWeight: 500,
            color: "#E84E4E",
          }}
        >
          Collection Gap
        </p>
        <StyledTooltip value={gapOriginal}>
          <p
            style={{
              margin: "0 0 6px",
              fontSize: "clamp(20px, 2.5vw, 28px)",
              fontWeight: 700,
              color: "#E84E4E",
              letterSpacing: "-0.5px",
              lineHeight: 1,
            }}
          >
            {gap}
          </p>
        </StyledTooltip>
        <p
          style={{
            margin: 0,
            fontSize: "clamp(11px, 0.8vw, 13px)",
            fontWeight: 400,
            color: "#E84E4E",
          }}
        >
          Pending collection
        </p>
      </div>
      {/* <div
        style={{
          background: "#FFF5F5",
          borderRadius: 12,
          padding: "18px 20px",
          border: "1px solid #fee1ca",
          marginTop: '10px'
        }}
      >
        <p
          style={{
            margin: "0 0 8px",
            fontSize: "clamp(11px, 0.8vw, 13px)",
            fontWeight: 500,
            color: "#e89b4e",
          }}
        >
          Overdue Amount
        </p>
        <StyledTooltip value={gapOriginal}>
          <p
            style={{
              margin: "0 0 6px",
              fontSize: "clamp(20px, 2.5vw, 28px)",
              fontWeight: 700,
              color: "#e89b4e",
              letterSpacing: "-0.5px",
              lineHeight: 1,
            }}
          >
            {'0' ?? gap}
          </p>
        </StyledTooltip>
        
      </div> */}
    </div>
  );
}

const BD = [
  { label: "Principal", value: "₹68.00L" },
  { label: "Interest", value: "₹18.00L" },
  { label: "Processing Fees", value: "₹4.00L" },
  // { label: "Charges", value: "₹2.00L" },
];

export default function DisbursalTracking({ selectedMonth, commonFilter }) {
  const { w } = useWindowSize();

  const [currentFilterDate, setCurrentFilterDate] = useState({ start: "", end: "" })
  const [tableListPopup, setTableListPopup] = useState(false)
  const [activeEmi, setActiveEmi] = useState(null);
  const [InfoActiveEmi, setInfoActiveEmi] = useState(null);
  const [commentsData, setCommentsData] = useState({});
  const [apiData, setApiData] = useState(null);
  const [emiData, setEmiData] = useState(null);
  const [collectionBreakdownData, setcollectionBreakdownData] = useState(null);
  const [collectionSummaryData, setCollectionSummaryData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingDisbursal, setLoadingDisbursal] = useState(false);
  const [loadingEmi, setLoadingEmi] = useState(false);
  const [loadingCollectionBreakdown, setLoadingCollectionBreakdown] = useState(false);
  const [loadingCollectionSummary, setLoadingCollectionSummary] = useState(false);
  const [error, setError] = useState(null);
  const [emiCardShow, setemiCardShow] = useState("emi")

  const addComment = (emiNo, newComment) => {
    setCommentsData((prev) => ({
      ...prev,
      [emiNo]: [newComment, ...(prev[emiNo] || [])],
    }));
  };


  const handleInfoPopup = (e) => {
    console.log('e l l', e)
    setInfoActiveEmi(e)
    setTableListPopup(true)
  }

  useEffect(() => {
    if (activeEmi) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
    return () => {
      document.body.style.overflow = "visible";
    };
  }, [activeEmi]);

  useEffect(() => {
    if (selectedMonth && selectedMonth?.length > 0) {
      // setLoading(true);
      setLoadingDisbursal(true);
      setLoadingEmi(true);
      setLoadingCollectionBreakdown(true);
      setLoadingCollectionSummary(true);
      setError(null);

      const monthMap = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3,
        May: 4, Jun: 5, Jul: 6, Aug: 7,
        Sep: 8, Oct: 9, Nov: 10, Dec: 11
      };

      const sortedMonths = [...selectedMonth]?.sort((a, b) => {
        const [mA, yA] = a.split(" ");
        const [mB, yB] = b.split(" ");

        return new Date(yA, monthMap[mA]) - new Date(yB, monthMap[mB]);
      });

      const [startMonthName, startYear] = sortedMonths[0].split(" ");
      const [endMonthName, endYear] =
        sortedMonths[sortedMonths.length - 1].split(" ");

      const startMonthIndex = monthMap[startMonthName];
      const endMonthIndex = monthMap[endMonthName];

      // const startDate = `01-${String(startMonthIndex + 1).padStart(2, "0")}-${startYear}`;

      const lastDay = new Date(endYear, endMonthIndex + 1, 0).getDate();
      // const endDate = `${lastDay}-${String(endMonthIndex + 1).padStart(2, "0")}-${endYear}`;
      const startDate = moment(commonFilter?.fromDate, "YYYY-MM-DD").format("DD-MM-YYYY");
      const endDate = moment(commonFilter?.toDate, "YYYY-MM-DD").format("DD-MM-YYYY");

      setCurrentFilterDate({ start: startDate, end: endDate })

      let completedCalls = 0;
      const totalCalls = 4;

      // const handleFinally = () => {
      //   completedCalls++;
      //   if (completedCalls === totalCalls) {
      //     setLoading(false);
      //   }
      // };

      // Fetch disbursal, EMI breakdown, and collection summary data
      // Promise.all([
      //   new Promise((resolve, reject) => {
      //     getDisbursalData(startDate, endDate,commonFilter?.nbfc ?? "", resolve, reject);
      //   }),
      //   new Promise((resolve, reject) => {
      //     getEmiBreakdown(startDate, endDate,commonFilter?.nbfc ?? "", resolve, reject);
      //   }),
      //   new Promise((resolve, reject) => {
      //     getcollectionBreakdown(startDate, endDate,commonFilter?.nbfc ?? "", resolve, reject);
      //   }),
      //   new Promise((resolve, reject) => {
      //     getCollectionSummary(startDate, endDate,commonFilter?.nbfc ?? "", resolve, reject);
      //   })
      // ])
      //   .then(([disbursalResponse, emiResponse,collectionBreakdownResponse, collectionResponse]) => {
      //     setLoading(false);

      //     if (disbursalResponse?.status === 200 && disbursalResponse?.data) {
      //       setApiData(disbursalResponse?.data);
      //     }

      //     if (emiResponse?.status === 200 && emiResponse?.data) {
      //       setEmiData(emiResponse?.data);
      //     }
      //     if (collectionBreakdownResponse?.status === 200 && collectionBreakdownResponse?.data) {
      //       setcollectionBreakdownData(collectionBreakdownResponse?.data);
      //     }

      //     if (collectionResponse?.status === 200 && collectionResponse?.data) {
      //       setCollectionSummaryData(collectionResponse?.data);
      //     }
      //   })
      //   .catch((err) => {
      //     setLoading(false);
      //     setError("Failed to fetch data: " + err?.message);
      //   });

      getDisbursalData(
        startDate,
        endDate,
        commonFilter?.nbfc ?? "",
        (res) => {
          if (res?.status === 200 && res?.data) {
            setApiData(res.data);
          }
          setLoadingDisbursal(false);
        },
        (err) => {
          setError("Disbursal failed: " + err?.message);
          setLoadingDisbursal(false);
        }
      );

      // 2. EMI Breakdown
      getEmiBreakdown(
        startDate,
        endDate,
        commonFilter?.nbfc ?? "",
        (res) => {
          if (res?.status === 200 && res?.data) {
            setEmiData(res.data);
          }
          setLoadingEmi(false);
        },
        (err) => {
          setError("EMI failed: " + err?.message);
          setLoadingEmi(false);
        }
      );

      // 3. Collection Breakdown
      getcollectionBreakdown(
        startDate,
        endDate,
        commonFilter?.nbfc ?? "",
        (res) => {
          if (res?.status === 200 && res?.data) {
            setcollectionBreakdownData(res.data);
          }
          setLoadingCollectionBreakdown(false);
        },
        (err) => {
          setError("Collection breakdown failed: " + err?.message);
          setLoadingCollectionBreakdown(false);
        }
      );

      // 4. Collection Summary
      getCollectionSummary(
        startDate,
        endDate,
        commonFilter?.nbfc ?? "",
        (res) => {
          if (res?.status === 200 && res?.data) {
            setCollectionSummaryData(res.data);
            setLoadingCollectionSummary(false);
          }
        },
        (err) => {
          setError("Collection summary failed: " + err?.message);
          setLoadingCollectionSummary(false);
        }
      );
    }
  }, [selectedMonth, commonFilter]);

  // Map API data to component structure
  const currentData = apiData ? {
    stats: {
      totalCases: apiData?.totalCasesDisbursed || 0,
      amountDisbursed: apiData?.amountDisbursedDisplay || "0",
      amountDisbursedOriginal: apiData?.amountDisbursed || "0",
      loansWithPF: apiData?.loansWithPF || 0,
      loansWithPFDISPALY: apiData?.loansWithPFDisplay || 0,
      loansWithoutPF: apiData?.loansWithoutPF || 0,
      loansWithoutPFDISPLAY: apiData?.loansWithoutPFDisplay || 0,
      freshCases: `${apiData?.freshCases || 0} (${apiData?.freshPercentage}%)`,
      RepeatCases: `${apiData?.repeatCases || 0} (${apiData?.repeatPercentage}%)`,
      FreshAmount: `${apiData?.freshDisburseAmountDisplay || 0}`,
      FreshAmountOrignal: `${apiData?.freshDisburseAmount || 0}`,
      RepeatAmount: `${apiData?.repeatDisburseAmountDisplay || 0} `,
      RepeatAmountOrignal: `${apiData?.repeatDisburseAmount || 0}`,
    },
    breakdown: {
      totalDisbursed: apiData?.amountDisbursedDisplay || "0",
      principalRepaidOriginal: apiData?.financialBreakdown?.principal?.amount || "0",
      principalRepaid: apiData?.financialBreakdown?.principal?.display || "0",
      interestCollectedOriginal: apiData?.financialBreakdown?.interest?.amount || "0",
      interestCollected: apiData?.financialBreakdown?.interest?.display || "0",
      outstandingOriginal: apiData?.financialBreakdown?.processingFee?.amount || "0",
      outstanding: apiData?.financialBreakdown?.processingFee?.display || "0",
      principalPct: apiData?.financialBreakdown?.principal?.percentage || "0",
      interestPct: apiData?.financialBreakdown?.interest?.percentage || "0",
      processingFeePct: apiData?.financialBreakdown?.processingFee?.percentage || "0",
      chargesPct: apiData?.financialBreakdown?.charges?.percentage || "0",
      processingFeeAmount: apiData?.financialBreakdown?.processingFee?.display || "0",
      chargesAmount: apiData?.financialBreakdown?.charges?.display || "0",
      chargesAmountOriginal: apiData?.financialBreakdown?.charges?.amount || "0",
    },
    collection: collectionSummaryData ? {
      collectionRate: `${collectionSummaryData?.collectionRate.toFixed(1)}%`,
      // totalDue: `₹${(collectionSummaryData?.totalDue / 100000).toFixed(2)}L`,
      totalDue: `${collectionSummaryData?.totalDueDisplay || 0}`,
      totalDueOriginal: collectionSummaryData?.totalDue || 0,
      // totalCollected: `₹${(collectionSummaryData?.totalCollectedDisplay / 100000).toFixed(2)}L`,
      totalCollected: `${collectionSummaryData?.totalCollectedDisplay || 0}`,
      totalCollectedOriginal: collectionSummaryData?.totalCollected || 0,
      collectionGap: `${collectionSummaryData?.collectionGapDisplay}`,
      collectionGapOriginal: collectionSummaryData?.collectionGap || 0,
      // pending: `₹${(collectionSummaryData?.pending / 100000).toFixed(2)}L`,
      pending: `${collectionSummaryData?.pendingDisplay || 0}`,
      pendingOriginal: collectionSummaryData?.pending || 0,
      defaulted: `${collectionSummaryData?.defaultedDisplay}`,
      defaultedOriginal: collectionSummaryData?.defaulted || 0,
      totalCollectedTillDate: `${collectionSummaryData?.collectableToDateDisplay || 0}`,
      totalCollectedOriginalTillDate: collectionSummaryData?.collectableToDate || 0,
    } : null,
  } : {
    stats: {
      totalCases: 0,
      amountDisbursed: "0",
      amountDisbursedOriginal: 0,
      loansWithPF: 0,
      loansWithoutPF: 0,
    },
    breakdown: {
      totalDisbursed: "0",
      principalRepaid: "0",
      interestCollected: "0",
      outstanding: "0",
      principalPct: "0",
      interestPct: "0",
      processingFeePct: "0",
      chargesPct: "0",
      processingFeeAmount: "0",
      chargesAmount: "0",
      chargesAmountOriginal: "0",
      interestCollectedOriginal: "0",
      outstandingOriginal: "0",
      principalRepaidOriginal: "0",
    },
    collection: null,
  };

  function CollectionStatsSkeleton({ isXs }) {
  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(5, 1fr)",
      gap: isXs ? 10 : 14,
      marginBottom: isXs ? 14 : 16,
    }}>
      {[1, 2, 3, 4, 5].map(i => (
        <div key={i} style={{
          background: "#F9FAFB",
          borderRadius: 12,
          padding: "20px 18px",
          minHeight: 110,
          border: "0.8px solid #E5E7EB",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 10,
          boxSizing: "border-box",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <SkeletonBox width={32} height={32} borderRadius={8} />
            <SkeletonBox width={80} height={20} />
          </div>
          <SkeletonBox width="70%" height={12} />
        </div>
      ))}
    </div>
  );
}


  const getTabStyle = (tab) => ({
    padding: "5px 14px",
    borderRadius: "16px",
    fontSize: window.innerWidth > 1800 ? "16px" : "14px",
    fontWeight: 500,
    transition: "all 0.2s ease",
    background: emiCardShow === tab ? "#fff" : "transparent",
    color: emiCardShow === tab ? "#111" : "#888",
    boxShadow: emiCardShow === tab ? "0 0 0 0.5px #d0d0d0" : "none",
  });

  const switchWrapperStyle = {
    display: "flex",
    alignItems: "center",
    border: "0.5px solid #d0d0d0",
    borderRadius: "20px",
    padding: "3px",
    cursor: "pointer",
    background: "#f5f5f5",
    flexShrink: 0,
    marginLeft: "24px",
    userSelect: "none",
  };


  // Map EMI API data to component structure
  const EMIS = emiData?.emiStages ? emiData.emiStages.map((stage, index) => {
    const accentColors = ["#3B82F6", "#10B981", "#F49F28", "#84CC16", "#0EA5E9", "#6366F1"];
    const badgeBgs = ["#3B82F61F", "#35A04F2B", "#F49F281F", "#F7FEE7", "#F0F9FF", "#EEF2FF"];
    const badgeColors = ["#3B82F6", "#327E45", "#EA580C", "#65A30D", "#0369A1", "#4338CA"];

    return {
      emi: stage?.emiSequence,
      cases: stage?.totalCases,
      month: stage?.month,
      amountOriginal: stage?.collectionAmount,
      amount: stage?.collectionAmountDisplay || 0,
      collectedamountOriginal: stage?.collectedAmount,
      collectedamount: stage?.collectedAmountDisplay || 0,
      collectableMonthToDate: stage?.collectableMonthToDate ?? null,
      collectableMonthToDateDisplay: stage?.collectableMonthToDateDisplay ?? null,
      breakdown: [
        { label: "Principal", value: stage?.principalDisplay || 0, originalValue: stage?.principal },
        { label: "Interest", value: stage?.interestDisplay || 0, originalValue: stage?.interest },
        // { label: "Processing Fees", value: stage?.processingFeesDisplay || `${(stage?.processingFees / 100000).toFixed(2)}L`, originalValue: stage?.processingFees },
        { label: "Charges", value: stage?.chargesDisplay || 0, originalValue: stage?.charges },
      ],
      pct: `${stage?.portfolioPercentage?.toFixed(1)}%`,
      accentColor: accentColors?.[index % accentColors?.length],
      badgeBg: badgeBgs?.[index % badgeBgs?.length],
      badgeColor: badgeColors?.[index % badgeColors?.length],
    }
  }) : [];
  const collectionEMIS = collectionBreakdownData?.months ? collectionBreakdownData?.months?.map((stage, index) => {
    const accentColors = ["#3B82F6", "#10B981", "#F49F28", "#84CC16", "#0EA5E9", "#6366F1"];
    const badgeBgs = ["#3B82F61F", "#35A04F2B", "#F49F281F", "#F7FEE7", "#F0F9FF", "#EEF2FF"];
    const badgeColors = ["#3B82F6", "#327E45", "#EA580C", "#65A30D", "#0369A1", "#4338CA"];

    return {
      emi: stage?.emiSequence,
      cases: stage?.totalCases,
      month: stage?.month,
      amountOriginal: stage?.expectedAmount,
      amount: stage?.expectedAmountDisplay || 0,
      collectedamountOriginal: stage?.collectedAmount,
      collectedamount: stage?.collectedAmountDisplay || 0,
      collectableMonthToDate: stage?.collectableMonthToDate ?? null,
      collectableMonthToDateDisplay: stage?.collectableMonthToDateDisplay ?? null,
      breakdown: [
        { label: "Principal", value: stage?.principalDisplay || 0, originalValue: stage?.principal },
        { label: "Interest", value: stage?.interestDisplay || 0, originalValue: stage?.interest },
        // { label: "Processing Fees", value: stage?.processingFeesDisplay || `${(stage?.processingFees / 100000).toFixed(2)}L`, originalValue: stage?.processingFees },
        { label: "Charges", value: stage?.chargesDisplay || 0, originalValue: stage?.charges },
      ],
      pct: `${stage?.portfolioPercentage?.toFixed(1)}%`,
      accentColor: accentColors?.[index % accentColors?.length],
      badgeBg: badgeBgs?.[index % badgeBgs?.length],
      badgeColor: badgeColors?.[index % badgeColors?.length],
      overdueAgingBuckets: stage?.overdueAgingBuckets ?? []
    }
  }) : [];

  const scrollbarStyles = `
  /* ...existing styles... */
  @keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

  function SkeletonBox({ width = "100%", height = 16, borderRadius = 8, style = {} }) {
    return (
      <div style={{
        width,
        height,
        borderRadius,
        background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.4s infinite",
        flexShrink: 0,
        ...style
      }} />
    );
  }

  function EmiSectionSkeleton({ emiCardWidth, summaryWidth }) {
    return (
      <div style={{ display: "flex", gap: "14px", width: "100%", alignItems: "stretch" }}>
        {/* EMI cards skeleton */}
        <div style={{ flex: 1, minWidth: 0, overflowX: "hidden", display: "flex", gap: "12px" }}>
          {[1, 2, 3, 4].map(i => (
            <div key={i} style={{
              width: emiCardWidth,
              flexShrink: 0,
              background: "#fff",
              borderRadius: 16,
              padding: "18px",
              border: "1.6px solid #E5E7EB",
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              gap: 10
            }}>
              {/* Header row */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <SkeletonBox width={50} height={14} />
                  <SkeletonBox width={70} height={22} borderRadius={999} />
                </div>
                <div style={{ display: "flex", gap: 5 }}>
                  <SkeletonBox width={28} height={28} borderRadius={7} />
                  <SkeletonBox width={28} height={28} borderRadius={7} />
                </div>
              </div>
              {/* Month */}
              <SkeletonBox width={60} height={12} />
              <SkeletonBox width={100} height={28} />
              {/* Collectable Amount */}
              <SkeletonBox width={120} height={12} />
              <SkeletonBox width={90} height={24} />
              {/* Collected Amount */}
              <SkeletonBox width={110} height={12} />
              <SkeletonBox width={90} height={24} />
              {/* Breakdown */}
              <div style={{ borderTop: "1px solid #E5E7EB", paddingTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
                <SkeletonBox width={80} height={12} />
                {[1, 2, 3].map(j => (
                  <div key={j} style={{ display: "flex", justifyContent: "space-between" }}>
                    <SkeletonBox width="45%" height={12} />
                    <SkeletonBox width="30%" height={12} />
                  </div>
                ))}
              </div>
              {/* Portfolio % */}
              <div style={{ borderTop: "1px solid #F3F4F6", paddingTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
                <SkeletonBox width={120} height={12} />
                <SkeletonBox width={50} height={22} />
              </div>
            </div>
          ))}
        </div>
        {/* Collection summary panel skeleton */}
        <div style={{ width: summaryWidth, flexShrink: 0, display: "flex", flexDirection: "column", gap: 10 }}>
          <div style={{ background: "#f6fdf8", borderRadius: 12, padding: "18px 20px", border: "1px solid #D1FAE5", display: "flex", flexDirection: "column", gap: 10 }}>
            <SkeletonBox width={140} height={12} />
            <SkeletonBox width={80} height={32} />
            <div style={{ display: "flex", gap: 32, marginTop: 4 }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <SkeletonBox width={60} height={10} />
                <SkeletonBox width={80} height={14} />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <SkeletonBox width={60} height={10} />
                <SkeletonBox width={80} height={14} />
              </div>
            </div>
          </div>
          <div style={{ background: "#FFF5F5", borderRadius: 12, padding: "18px 20px", border: "1px solid #FECACA", marginTop: 10, display: "flex", flexDirection: "column", gap: 10 }}>
            <SkeletonBox width={110} height={12} />
            <SkeletonBox width={90} height={28} />
            <SkeletonBox width={130} height={10} />
          </div>
        </div>
      </div>
    );
  }

  function CollectionSummarySkeleton({ isXs }) {
    return (
      <>
        {/* Top 5 stat cards */}
        <div style={{
          display: "grid",
          gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(5, 1fr)",
          gap: isXs ? 10 : 14,
          marginBottom: isXs ? 14 : 16,
        }}>
          {[1, 2, 3, 4, 5].map(i => (
            <div key={i} style={{
              background: "#F9FAFB",
              borderRadius: 12,
              padding: "20px 18px",
              minHeight: 110,
              border: "0.8px solid #E5E7EB",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: 10
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <SkeletonBox width={32} height={32} borderRadius={8} />
                <SkeletonBox width={80} height={20} />
              </div>
              <SkeletonBox width="70%" height={12} />
            </div>
          ))}
        </div>
        {/* Bottom 2 large stat boxes */}
        <div style={{
          display: "grid",
          gridTemplateColumns: isXs ? "1fr" : "1fr 1fr",
          gap: "14px",
          marginTop: 30
        }}>
          {[1, 2].map(i => (
            <div key={i} style={{
              background: "#F9FAFB",
              borderRadius: 12,
              padding: isXs ? "18px 16px" : "22px 24px",
              border: "0.8px solid #E5E7EB",
              display: "flex",
              flexDirection: "column",
              gap: 12
            }}>
              <SkeletonBox width={120} height={14} />
              <SkeletonBox width={160} height={44} />
              <SkeletonBox width={100} height={12} />
            </div>
          ))}
        </div>
      </>
    );
  }

  function DisbursalStatsSkeleton({ compact, count = 4 }) {
    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "14px", marginBottom: "20px" }}>
        {Array(count).fill(0).map((_, i) => (
          <div key={i} style={{
            flex: compact ? "1 1 calc(50% - 8px)" : "1 1 0",
            borderRadius: 16,
            padding: compact ? "16px 18px" : "24px 28px",
            background: "#F9FAFB",
            border: "0.8px solid #E5E7EB",
            minWidth: 0,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <SkeletonBox width={44} height={44} borderRadius={10} />
              <SkeletonBox width={90} height={26} />
            </div>
            <SkeletonBox width="60%" height={13} />
          </div>
        ))}
      </div>
    );
  }

  function FinancialBreakdownSkeleton({ isXs }) {
    return (
      <div style={{
        background: "#F9FAFB",
        borderRadius: 16,
        padding: "24px 28px",
        border: "0.8px solid #E5E7EB",
        marginBottom: "20px"
      }}>
        <SkeletonBox width={180} height={20} style={{ marginBottom: 18 }} />
        <div style={{
          display: "flex",
          flexWrap: isXs ? "wrap" : "nowrap",
          gap: "14px"
        }}>
          {[1, 2, 3].map(i => (
            <div key={i} style={{
              flex: isXs ? "1 1 calc(50% - 8px)" : "1 1 0",
              background: "#fff",
              borderRadius: 12,
              padding: "18px 20px",
              border: "0.8px solid #E5E7EB",
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              gap: 10
            }}>
              <SkeletonBox width="55%" height={13} />
              <SkeletonBox width={100} height={22} />
              <SkeletonBox width="40%" height={11} style={{ marginTop: 4 }} />
            </div>
          ))}
        </div>
      </div>
    );
  }
  { loadingCollectionSummary ? <Loader /> : "" }
  { loadingCollectionBreakdown ? <Loader /> : "" }

  // Error state
  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '400px',
        color: '#E7000B',
        fontSize: '16px'
      }}>
        {error}
      </div>
    );
  }

  const isXs = w < 480;
  const isSm = w >= 480 && w < 768;
  const isMd = w >= 768 && w < 1024;
  const isLg = w >= 1024;

  const compact = isXs || isSm;
  const padding = isXs ? 16 : isSm ? 20 : isMd ? 24 : 32;
  const sectionPad = isXs ? "16px 16px" : isSm ? "18px 18px" : "24px 28px";

  const summaryBelow = isXs || isSm;
  const emiCardWidth = window.innerWidth > 1800 ? 300 : 260;

  return (
    <React.Fragment>
      <style>{scrollbarStyles}</style>
      <div
        style={{
          // fontFamily: FONT,
          maxWidth: 2500,
          margin: "0 auto",
          padding,
          background: "#fff",
          boxSizing: "border-box",
          borderRadius: "16px",
          border: "1px solid rgb(226, 232, 240)",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          marginTop: "40px",
        }}
      >
        <div style={{ marginBottom: isXs ? 16 : 24 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 6,
            }}
          >
            <div
              style={{
                width: 24,
                height: 24,
                borderRadius: 6,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FileSpreadsheet color="#155DFC" />
            </div>
            <h1
              style={{
                margin: 0,
                fontSize: "clamp(15px, 2vw, 20px)",
                fontWeight: 600,
                color: "#101828",
                letterSpacing: "-0.3px",
              }}
            >
              Disbursal Tracking
            </h1>
          </div>
          <p
            style={{
              margin: "8px 0",
              fontSize: "clamp(11px, 0.9vw, 14px)",
              color: "#6B7280",
              marginLeft: 0,
              fontWeight: 400,
            }}
          >
            {selectedMonth?.length > 0
              ? `Month: ${selectedMonth?.join(", ")}`
              : "No months selected"}
          </p>
        </div>
        {loadingDisbursal ? (
          <DisbursalStatsSkeleton compact={compact} count={4} />) : (
          <div
            style={{
              display: "flex",
              flexWrap: isLg ? "nowrap" : "wrap",
              gap: commonGap,
              marginBottom: commonMargin
            }}
          >
            <StatCard
              customId="0"
              Icon={IconUsers}
              iconColor="#155DFC"
              iconBg="#DBEAFE"
              value={currentData.stats ? currentData.stats.totalCases : "200"}
              label="Total Cases Disbursed"
              cardBg="#EFF6FF"
              compact={compact}
              valueColor="#1C398E"
              Border="0.8px solid #DBEAFE"
            />
            <StatCard

              originalValue={currentData.stats?.amountDisbursedOriginal}
              Icon={IconDollar}
              iconColor="#00A63E"
              iconBg="#DCFCE7"
              value={
                currentData.stats
                  ? currentData.stats.amountDisbursed
                  : "₹6.00Cr"
              }
              label="Amount Disbursed"
              cardBg="#F0FDF4"
              compact={compact}
              valueColor="#0D542B"
              Border="0.8px solid #DCFCE7"
            />
            <StatCard
              originalValue={currentData.stats?.loansWithPF}
              Icon={IconCheckCircle}
              iconColor="#9810FA"
              iconBg="#F3E8FF"
              value={currentData.stats ? currentData.stats.loansWithPFDISPALY : "165"}
              label="Loans with PF"
              cardBg="#FAF5FF"
              compact={compact}
              valueColor="#59168B"
              Border="0.8px solid #F3E8FF"
            />
            <StatCard
              originalValue={currentData.stats?.loansWithoutPF}
              Icon={IconCheckCircle}
              iconColor="#F54900"
              iconBg="#FFEDD4"
              value={currentData.stats ? currentData.stats.loansWithoutPFDISPLAY : "35"}
              label="Loans without PF"
              cardBg="#FFF7ED"
              compact={compact}
              valueColor="#7E2A0C"
              Border="0.8px solid #FFEDD4"
            />
          </div>
        )}
        {loadingDisbursal ? (
          <DisbursalStatsSkeleton compact={compact} count={4} />) : (
          <div
            style={{
              display: "flex",
              flexWrap: isLg ? "nowrap" : "wrap",
              gap: commonGap,
              marginBottom: commonMargin
            }}
          >
            {/* <StatCard
          customId="0"
            Icon={IconUsers}
            iconColor="#155DFC"
            iconBg="#DBEAFE"
            value={currentData.stats ? currentData.stats.freshCases : "0"}
            label="Fresh Cases"
            cardBg="#eff9ff"
            compact={compact} 
            valueColor="#1C398E"
            Border="0.8px solid #DBEAFE"
          /> */}
            {/* <StatCard
            
            customId="0"
            Icon={IconUsers}
            iconColor="#00A63E"
            iconBg="#DCFCE7"
            value={
              currentData.stats
                ? currentData.stats?.RepeatCases
                : "₹6.00Cr"
            }
            label="Repeat Cases"
            cardBg="#f0fdf7"
            compact={compact}
            valueColor="#0D542B"
            Border="0.8px solid #DCFCE7"
          /> */}
            <StatCard
              customId="0"
              Icon={IconUsers}
              iconColor="#C2410C"
              iconBg="#FFE4CC"
              value={currentData.stats ? currentData.stats.freshCases : "0"}
              label="Fresh Cases"
              cardBg="#FFF4E6"
              compact={compact}
              valueColor="#C2410C"
              Border="0.8px solid #DBEAFE"
            />
            <StatCard
              originalValue={currentData.stats?.FreshAmountOrignal}
              Icon={IconDollar}
              iconColor="#B45309"
              iconBg="#FEF3C7"
              value={currentData.stats ? currentData.stats.FreshAmount : "0"}
              label="Fresh Disbursement Amount"
              cardBg="#FFFBEB"
              compact={compact}
              valueColor="#B45309"
              Border="0.8px solid #DBEAFE"
            />
            <StatCard

              customId="0"
              Icon={IconUsers}
              iconColor="#BE123C"
              iconBg="#FFE4E6"
              value={
                currentData.stats
                  ? currentData.stats?.RepeatCases
                  : "₹6.00Cr"
              }
              label="Repeat Cases"
              cardBg="#FFF1F2"
              compact={compact}
              valueColor="#BE123C"
              Border="0.8px solid #DCFCE7"
            />
            <StatCard
              originalValue={currentData.stats?.RepeatAmountOrignal}
              Icon={IconDollar}
              iconColor="#7C2D12"
              iconBg="#F5E6D8"
              value={currentData.stats ? currentData.stats.RepeatAmount : "0"}
              label="Repeat Disbursement Amount"
              cardBg="#FDF6F0"
              compact={compact}
              valueColor="#7C2D12"
              Border="0.8px solid #DBEAFE"
            />

          </div>
        )}
        {loadingDisbursal ? (
  <FinancialBreakdownSkeleton isXs={isXs} />
) : (
        <div
          style={{
            background: "#F9FAFB",
            borderRadius: 16,
            padding: sectionPad,
            border: "0.8px solid #E5E7EB",
            marginBottom: commonMargin
          }}
        >
          <h6
            style={{
              margin: `0 0 ${isXs ? 12 : 18}px`,
              fontSize: "20px",
              fontWeight: 500,
              color: "#0A0A0A",
            }}
          >
            Financial Breakdown
          </h6>
          <div
            style={{
              display: "flex",
              flexWrap: isXs ? "wrap" : "nowrap",
              gap: commonGap,
            }}
          >
            <FinCard
              label="Principal"
              originalValue={currentData?.breakdown?.principalRepaidOriginal}
              value={
                currentData?.breakdown
                  ? currentData?.breakdown?.principalRepaid
                  : "₹465.00L"
              }
              pct={currentData?.breakdown ? `${currentData?.breakdown?.principalPct}%` : "77.5%"}
              compact={isXs}
            />
            <FinCard
              label="Interest"
              originalValue={currentData?.breakdown?.interestCollectedOriginal}
              value={
                currentData?.breakdown
                  ? currentData?.breakdown?.interestCollected
                  : "₹93.00L"
              }
              pct={currentData?.breakdown ? `${currentData?.breakdown?.interestPct}%` : "15.5%"}
              compact={isXs}
            />
            <FinCard
              label="Processing Fee Inclusive GST"
              originalValue={currentData?.breakdown?.outstandingOriginal}
              value={currentData?.breakdown ? currentData?.breakdown?.processingFeeAmount : "₹35.00L"}
              pct={currentData?.breakdown ? `${currentData?.breakdown?.processingFeePct}%` : "5.8%"}
              compact={isXs}
            />
            {/* <FinCard
              label="Charges"
              originalValue={currentData?.breakdown?.chargesAmountOriginal}
              value={currentData?.breakdown ? currentData?.breakdown?.chargesAmount : "₹7.00L"}
              pct={currentData?.breakdown ? `${currentData?.breakdown?.chargesPct}%` : "1.2%"}
              compact={isXs}
            /> */}
          </div>
        </div>
)}
        <div
          style={{
            background: "#F9FAFB",
            borderRadius: 16,
            padding: sectionPad,
            border: "0.8px solid #E5E7EB",

          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <div>
              <h6
                style={{
                  margin: `0 0 4px`,
                  fontSize: "20px",
                  fontWeight: 500,
                  color: "#101828",
                }}
              >
                EMI Breakdown
              </h6>
              <p
                style={{
                  margin: `0 0 ${isXs ? 14 : 20}px`,
                  fontSize: "14px",
                  color: "#6A7282",
                  fontWeight: "400",
                }}
              >
                Distribution of disbursed amount across upcoming EMI stages
              </p>
            </div>
            <div>
              <div style={switchWrapperStyle}>
                <div style={getTabStyle("emi")} onClick={() => setemiCardShow("emi")}>
                  EMI
                </div>
                <div
                  style={getTabStyle("collection")}
                  onClick={() => setemiCardShow("collection")}
                >
                  Collection
                </div>
              </div>

            </div>
          </div>

          {(loadingEmi && emiCardShow === "emi") || (loadingCollectionBreakdown && emiCardShow === "collection") ? (
            <EmiSectionSkeleton
              emiCardWidth={emiCardWidth}
              summaryWidth={window.innerWidth > 1800 ? 300 : 200}
            />
          ) : (
            <div
              className="emi-scroll"
              style={{
                display: "flex",
                gap: commonGap,
                width: "100%",
                alignItems: "stretch",
                flexWrap: summaryBelow ? "wrap" : "nowrap",
              }}
            >
              <div
                style={{
                  flex: 1,
                  minWidth: 0,
                  overflowX: "auto",
                  overflowY: "hidden",
                  paddingBottom: 6,
                }}
                className="emi-scroll-container"
              >
                <div
                  style={{
                    display: "flex",
                    gap: window.innerWidth > 1800 ? "20px" : '12px',
                    width: "max-content",
                  }}
                >
                  {emiCardShow == "emi" && EMIS && EMIS?.length > 0 && EMIS?.map((e, i) => (
                    <EmiCard
                      key={i}
                      {...e}
                      cardWidth={emiCardWidth}

                      onCardInfoClick={() => handleInfoPopup(e)}
                      onMessageClick={() => setActiveEmi(e)}
                    />
                  ))}
                  {emiCardShow == "collection" && collectionEMIS && collectionEMIS?.length > 0 && collectionEMIS?.map((e, i) => (
                    <EmiCard
                      key={i}
                      {...e}
                      cardWidth={emiCardWidth}

                      onCardInfoClick={() => handleInfoPopup(e)}
                      onMessageClick={() => setActiveEmi(e)}
                    />
                  ))}
                </div>
              </div>

              <div
                style={{
                  width: window.innerWidth > 1800 ? 300 : 200,
                  flexShrink: 0,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <CollectionSummary
                  rate={
                    currentData?.collection
                      ? currentData?.collection?.collectionRate
                      : "0%"
                  }
                  expected={
                    currentData?.collection
                      ? currentData?.collection?.totalDue
                      : "₹0.00L"
                  }
                  expectedOriginal={
                    currentData?.collection
                      ? currentData?.collection?.totalDueOriginal
                      : 0
                  }
                  collected={
                    currentData?.collection
                      ? currentData?.collection?.totalCollected
                      : "₹0.00L"
                  }
                  collectedOriginal={
                    currentData?.collection
                      ? currentData?.collection?.totalCollectedOriginal
                      : 0
                  }
                  gap={
                    currentData?.collection
                      ? currentData?.collection?.collectionGap
                      : "₹0.00L"
                  }
                  gapOriginal={
                    currentData?.collection
                      ? currentData?.collection?.collectionGapOriginal
                      : 0
                  }
                />
              </div>
            </div>
          )}
        </div>

        {activeEmi && (
          <Commentbox
            emiNo={activeEmi?.emi}
            month={activeEmi?.month}
            onClose={() => setActiveEmi(null)}
            comments={commentsData?.[activeEmi?.emi] || []}
            addComment={(comment) => addComment(activeEmi?.emi, comment)}
          />
        )}

        {
          tableListPopup &&
          <CustomPopupTable
            InfoActiveEmi={InfoActiveEmi}
            onClose={() => setTableListPopup(false)}
            currentFilterDate={currentFilterDate}
            emiCardShow={emiCardShow}
            nbfc={commonFilter?.nbfc}
          />
        }
      </div>

      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          padding: sectionPad,
          border: "1px solid #E5E7EB",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          margin: "20px auto",
          maxWidth: 2500,
          marginTop: commonMargin
        }}
      >
        <div style={{ marginBottom: isXs ? 16 : 20 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 4,
            }}
          >
            <div
              style={{
                width: 20,
                height: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#10B981"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            </div>
            <h2
              style={{
                margin: 0,
                fontSize: "20px",
                fontWeight: 600,
                color: "#101828",
              }}
            >
              Collection Summary
            </h2>
          </div>
          <p
            style={{
              margin: "8px 0",
              fontSize: "14px",
              color: "#6A7282",
              marginLeft: 0,
              fontWeight: "400",
            }}
          >
            {selectedMonth?.length > 0
              ? `Month: ${selectedMonth?.join(", ")}`
              : "No months selected"}
          </p>
        </div>

{loadingCollectionSummary ? (
  <CollectionStatsSkeleton isXs={isXs} />
) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isXs ? "1fr 1fr" : "repeat(5, 1fr)",
            gap: isXs ? 10 : 14,
            marginBottom: isXs ? 14 : 16,
          }}
        >
          {[
            {
              bg: "#EFF6FF",
              Border: "0.8px solid #DBEAFE",
              iconBg: "#DBEAFE",
              iconColor: "#3B82F6",
              valueColor: "#1E40AF",
              value: currentData.collection
                ? currentData.collection.totalDue
                : "₹0.00L",
              originalValue: currentData.collection
                ? currentData.collection.totalDueOriginal
                : 0,
              label: "Total Collectable Amount",
              icon: (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#3B82F6"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              ),
            },
            {
              bg: "rgb(250, 245, 255)",
              Border: "0.8px solid rgb(243, 232, 255)",
              iconBg: "rgb(243, 232, 255)",
              iconColor: "#59168b",
              valueColor: "rgb(89, 22, 139)",
              value: currentData.collection
                ? currentData.collection.totalCollectedTillDate
                : "₹0.00L",
              originalValue: currentData.collection
                ? currentData.collection.totalCollectedOriginalTillDate
                : 0,
              label: "Total Collectable Amount (By Today)",
              icon: (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#3B82F6"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              ),
            },
            {
              bg: "#ECFDF5",
              Border: "0.8px solid #DCFCE7",
              iconBg: "#D1FAE5",
              iconColor: "#10B981",
              valueColor: "#047857",
              value: currentData.collection
                ? currentData.collection.totalCollected
                : "₹0.00L",
              originalValue: currentData.collection
                ? currentData.collection.totalCollectedOriginal
                : 0,
              label: "Total Collected Amount",
              icon: (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#10B981"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              ),
            },
            {
              bg: "#FFFBEB",
              Border: "0.8px solid #FEF9C2",
              iconBg: "#FEF3C7",
              iconColor: "#F59E0B",
              valueColor: "#92400E",
              value: currentData.collection
                ? currentData.collection.pending
                : "₹0.60Cr",
              originalValue: currentData.collection
                ? currentData.collection.pendingOriginal || 0
                : 0,
              label: "Pending Amount",
              icon: (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#F59E0B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
              ),
            },
            {
              bg: "#FEF2F2",
              Border: "0.8px solid #FFE2E2",
              iconBg: "#FEE2E2",
              iconColor: "#EF4444",
              valueColor: "#991B1B",
              value: currentData.collection
                ? currentData.collection.defaulted
                : "₹0.18Cr",
              originalValue: currentData.collection
                ? currentData.collection.defaultedOriginal || 0
                : 0,
              label: "Defaulted Amount",
              icon: (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#EF4444"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
              ),
            },
          ]?.map(({ bg, iconBg, icon, valueColor, value, label, Border, originalValue }) => (
            <div
              style={{
                background: bg,
                borderRadius: 12,
                padding: "20px 18px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                minHeight: 110,
                border: Border
              }}
            >

              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    background: iconBg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {icon}
                </div>
                <StyledTooltip value={originalValue}>
                  <span
                    style={{
                      fontSize: "clamp(16px, 2vw, 20px)",
                      fontWeight: 700,
                      color: valueColor,
                      letterSpacing: "-0.5px",
                      lineHeight: 1,
                    }}
                  >
                    {value}
                  </span>
                </StyledTooltip>
              </div>

              <p
                style={{
                  margin: "12px 0 0",
                  fontSize: "clamp(11px, 0.9vw, 13px)",
                  fontWeight: 400,
                  color: "#64748B",
                }}
              >
                {label}
              </p>
            </div>
          ))}
        </div>
        )}
{loadingCollectionSummary ? (
  <div style={{
          background: "#F9FAFB",
          borderRadius: 12,
          padding: "20px 18px",
          minHeight: 110,
          border: "0.8px solid #E5E7EB",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 10,
          boxSizing: "border-box",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <SkeletonBox width={32} height={32} borderRadius={8} />
            <SkeletonBox width={80} height={20} />
          </div>
          <SkeletonBox width="70%" height={12} />
        </div>
):(
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isXs ? "1fr" : "1fr 1fr",
            gap: commonGap,
            marginTop: '30px'
          }}
        >
          {[
            {
              label: "Collection Rate",
              value: currentData?.collection
                ? currentData?.collection?.collectionRate
                : "0%",
              sub: "Overall Collection Rate",
              valueColor: "#00A63E",
            },
            {
              label: "Total Due Amount",
              value: currentData?.collection
                ? currentData?.collection?.collectionGap
                : "₹0.00L",
              originalValue: currentData?.collection
                ? currentData?.collection?.collectionGapOriginal
                : 0,
              sub: "Pending Collection",
              valueColor: "#E7000B",
            },
          ].map(({ label, value, sub, valueColor, originalValue }) => (
            <div
              style={{
                background: "#F9FAFB",
                borderRadius: 12,
                padding: isXs ? "18px 16px" : "22px 24px",
                border: "0.8px solid #E5E7EB",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 6,
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: "clamp(12px, 1.2vw, 14px)",
                  fontWeight: 400,
                  color: "#374151",
                  alignSelf: "flex-start",
                }}
              >
                {label}
              </p>
              {originalValue ? (
                <StyledTooltip value={originalValue}>
                  <h6
                    style={{
                      margin: "8px 0 0",
                      fontSize: window.innerWidth > 1800 ? "50px" : "40px",
                      fontWeight: 700,
                      color: valueColor,
                      letterSpacing: "-1.5px",
                      lineHeight: 1,
                    }}
                  >
                    {value}
                  </h6>
                </StyledTooltip>
              ) : (
                <h6
                  style={{
                    margin: "8px 0 0",
                    fontSize: window.innerWidth > 1800 ? "50px" : "40px",
                    fontWeight: 700,
                    color: valueColor,
                    letterSpacing: "-1.5px",
                    lineHeight: 1,
                  }}
                >
                  {value}
                </h6>
              )}
              <p
                style={{
                  margin: "4px 0 0",
                  fontSize: "clamp(10px, 0.8vw, 12px)",
                  color: "#6B7280",
                  fontWeight: 400,
                }}
              >
                {sub}
              </p>
            </div>
          ))}
        </div>
      )}
      </div>
    </React.Fragment>
  );
}
